// extracted by mini-css-extract-plugin
export default {"itemForm":"itemForm---N2RFL"};